import { render, staticRenderFns } from "./QuestionMatchRadio.vue?vue&type=template&id=4a08f7a7&scoped=true&"
import script from "./QuestionMatchRadio.vue?vue&type=script&lang=js&"
export * from "./QuestionMatchRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a08f7a7",
  null
  
)

export default component.exports